import { API_CALL } from 'actions/actionConstants'
import { AppAction } from 'actions/types/ActionTypes'
import { FETCH_MERCHANDISE_TOP_CATEGORIES } from 'actions/apiActionConstants'
import getMerchandiseTopCategories from 'api/merchandise/getMerchandiseTopCategories'

function fetchMerchandiseTopCategories(): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const existingState = state.merchandise.merchandiseTopCategories
    if (existingState) {
      return
    }

    dispatch({
      type: API_CALL,
      api: FETCH_MERCHANDISE_TOP_CATEGORIES,
      request: () => getMerchandiseTopCategories(),
    })
  }
}

export default fetchMerchandiseTopCategories
